import { render } from "./ReferralPlan.vue?vue&type=template&id=a1c74968&scoped=true"
import script from "./ReferralPlan.vue?vue&type=script&lang=js"
export * from "./ReferralPlan.vue?vue&type=script&lang=js"

import "@/assets/scss/_referral-plan.scss?vue&type=style&index=0&id=a1c74968&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c74968"]])

export default __exports__